import { all, fork, put, select } from 'redux-saga/effects';
import { routinePromiseWatcherSaga } from 'redux-saga-routines';
import * as qs from 'querystring';
import { actions } from '../actions/app';
import personalSection from '../components/PrivateSection/sagas';
import authModal from '../components/AuthModal/sagas';
import { root as configSelector } from '../selectors/config';
import app from './app';
import ssr from './ssr';
import tokens from './tokens';
import { RootState } from 'shared/reducers';
import { modals } from './modals';

function* showRecoveryPasswordModal() {
  const { search } = yield select((state: RootState) => state.router.location);
  const params = qs.parse(search.substring(1)); // cut leading "?"

  if (params.recoverPassword) {
    yield put(actions.showAuthModal('restore'));
  }
}

export default function* rootSaga() {
  const config: ReturnType<typeof configSelector> = yield select(configSelector);

  yield all([
    fork(tokens),
    fork(ssr),
    fork(routinePromiseWatcherSaga),
    fork(app, config),
    fork(personalSection),
    fork(authModal),
    fork(modals),
  ]);

  yield showRecoveryPasswordModal();
}
